// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1MDjO","info":"UpdateTermsInfo_info__1rNlN"};